import { axiosInstanceWebsite } from "../instance";

export const getSubDomain = async (websiteId: string) => {
    const response = await axiosInstanceWebsite.get(`/websites/subdomain/websiteId/${websiteId}`);
    return response.data;
};